import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthLayout } from "@/components/AuthLayout";
import { PasswordField, SubmitButton, FormMessage } from "@/components/Field";
import { api, formatApiError } from "@/lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("Les deux mots de passe ne correspondent pas.");
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    }
    setLoading(false);
  };

  return (
    <AuthLayout title="Nouveau mot de passe" subtitle="Choisis un mot de passe d'au moins 8 caractères.">
      {done ? (
        <div className="mt-8 space-y-5">
          <FormMessage success="Ton mot de passe a bien été modifié." />
          <Link to="/" data-testid="reset-go-login" className="block w-full rounded-full bg-bordeaux py-4 text-center font-sans text-base font-medium text-white transition hover:bg-bordeaux-dark">
            Me connecter
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="reset-form">
          <PasswordField label="Nouveau mot de passe" testId="reset-password-input" minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} />
          <PasswordField label="Confirme le mot de passe" testId="reset-confirm-input" minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          <FormMessage error={error} />
          <SubmitButton testId="reset-submit-button" loading={loading}>Enregistrer</SubmitButton>
        </form>
      )}
    </AuthLayout>
  );
}
